import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { AdminButton, AdminCard, AdminInput } from './AdminUI';

const AdminAuthContainer = () => {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const { isDark, toggleTheme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (!result.success) {
      setError(result.error || 'Login failed');
      return;
    }
    navigate('/admin/promo-codes', { replace: true });
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-100 p-4 dark:bg-slate-950">
      <div className="absolute right-4 top-4 z-10">
        <AdminButton onClick={toggleTheme} variant="secondary">
          {isDark ? 'Light Mode' : 'Dark Mode'}
        </AdminButton>
      </div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(6,182,212,0.22),transparent_35%),radial-gradient(circle_at_80%_0%,rgba(99,102,241,0.2),transparent_30%),radial-gradient(circle_at_50%_100%,rgba(14,165,233,0.16),transparent_30%)] dark:bg-[radial-gradient(circle_at_20%_20%,rgba(6,182,212,0.35),transparent_35%),radial-gradient(circle_at_80%_0%,rgba(99,102,241,0.35),transparent_30%),radial-gradient(circle_at_50%_100%,rgba(14,165,233,0.3),transparent_30%)]" />
      <AdminCard className="relative w-full max-w-md border-slate-300 bg-white/90 p-8 shadow-2xl shadow-cyan-500/10 dark:border-slate-700 dark:bg-slate-900/85 dark:shadow-cyan-900/30">
        <p className="mb-2 text-xs uppercase tracking-[0.2em] text-cyan-600 dark:text-cyan-300">Admin Portal</p>
        <h1 className="mb-2 text-3xl font-semibold text-slate-900 dark:text-white">Welcome Back</h1>
        <p className="mb-6 text-sm text-slate-600 dark:text-slate-300">Sign in to control campaigns, affiliates, and users.</p>
        {error ? <div className="mb-4 rounded-lg border border-rose-400/50 bg-rose-500/20 px-3 py-2 text-sm text-rose-700 dark:text-rose-100">{error}</div> : null}
        <form onSubmit={handleSubmit} className="space-y-4">
          <AdminInput
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email or username"
            className="border-slate-300 bg-white text-slate-900 placeholder:text-slate-400 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
            required
          />
          <AdminInput
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="border-slate-300 bg-white text-slate-900 placeholder:text-slate-400 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
            required
          />
          <AdminButton type="submit" className="w-full bg-cyan-500 py-3 font-semibold text-slate-950 hover:bg-cyan-400" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </AdminButton>
        </form>
      </AdminCard>
    </div>
  );
};

export default AdminAuthContainer;
